import { Component } from '../lib/ComponentBase';
import { registerComponent } from '../lib/ComponentHelpers';
import HexCoords from "../grid/HexCoords";
import type { Bearing } from "../grid/HexBearing";

export default class HexPosition extends Component {
  coords: HexCoords;
  bearing: Bearing;

  constructor(data: { coords: { q: number, r: number }, bearing: Bearing } = { coords: { q: 0, r: 0 }, bearing: 1 }) {
    super();
    this.coords = HexCoords.get(data.coords);
    this.bearing = data.bearing;
  }

  equals(other: this): boolean {
    // Validate that coords is properly hydrated as HexCoords instance
    if (!(other.coords instanceof HexCoords)) {
      console.error(`HexPosition.equals: other.coords is not a HexCoords instance`, other.coords);
      return false;
    }

    return this.coords.q === other.coords.q &&
           this.coords.r === other.coords.r &&
           this.bearing === other.bearing;
  }

  static getTestInstances(): HexPosition[] {
    return [
      new HexPosition({ coords: { q: 0, r: 0 }, bearing: 1 }),
      new HexPosition({ coords: { q: 5, r: -3 }, bearing: 6 }),
      new HexPosition({ coords: { q: -2, r: 2 }, bearing: 3 }),
    ];
  }

  toString(): string {
    return `<HexPosition Q: ${this.coords.q}, R: ${this.coords.r}, HexBearing: ${this.bearing}>`;
  }
}

registerComponent(HexPosition);
